window.theme.block('listing-hoteis', el => {
    function getQueryParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    function navigateToSelectedOption(selectElement) {
        const selectedOptionValue = selectElement.value;
        if (selectedOptionValue) {
            window.location.href = selectedOptionValue;
        }
    }

    // Selected destino
    const tourTypeValue = getQueryParam('destino-id');

    if (tourTypeValue) {
        const selectField = el.querySelector('select[name="destino-id"]');

        if (selectField) {
            selectField.value = tourTypeValue;

            const event = new Event('change', { bubbles: true });
            selectField.dispatchEvent(event);
        }
    }

    // Function to handle the redirection when the select value changes
    const selectField = el.querySelector('#tour-type');
    if (selectField) {
        selectField.addEventListener('change', () => {
            navigateToSelectedOption(selectField);
        });
    }
});
